import { inject, Pipe, PipeTransform } from '@angular/core';
import {
  appendToRmaApiUrl,
  appendToRmaBillingApiUrl,
  appendToRmaEmailApiUrl,
  appendToRmaFindMyApiUrl,
  appendToRmaReviewsApiUrl,
  appendToRmaSocialApiUrl,
  appendToRmaSurveyApiUrl,
} from '@rma/generic/ng/util';
import { RmaApiUrlType } from './rma-api-type.const';

@Pipe({
  name: 'rmaApiUrl',
  standalone: true,
})
export class RmaApiUrlPipe implements PipeTransform {
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);
  private readonly reviewsApiUrl = inject(appendToRmaReviewsApiUrl);
  private readonly socialApiUrl = inject(appendToRmaSocialApiUrl);
  private readonly surveyApiUrl = inject(appendToRmaSurveyApiUrl);
  private readonly billingApiUrl = inject(appendToRmaBillingApiUrl);
  private readonly emailApiUrl = inject(appendToRmaEmailApiUrl);
  private readonly findMyApiUrl = inject(appendToRmaFindMyApiUrl);

  public transform(value: string, apiType: RmaApiUrlType = 'Rma'): string {
    switch (apiType) {
      case 'Reviews':
        return this.reviewsApiUrl(value);
      case 'Social':
        return this.socialApiUrl(value);
      case 'Survey':
        return this.surveyApiUrl(value);
      case 'Billing':
        return this.billingApiUrl(value);
      case 'Email':
        return this.emailApiUrl(value);
      case 'FindMyAgent':
        return this.findMyApiUrl(value);
      default:
        return this.rmaApiUrl(value);
    }
  }
}
